import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const languageDetector = new LanguageDetector();
languageDetector.addDetector({
    name: 'facilitatripLanguageDetector',
    lookup(options) {
        const stored = localStorage.getItem('language_code');
        if (stored) {
            return stored;
        }
        if (navigator.language?.includes('en')) {
            return 'en';
        }
        if (navigator.language?.includes('fr')) {
            return 'fr';
        }
        if (navigator.language?.includes('it')) {
            return 'it';
        }
        return  navigator.language;
    },
});

i18n.use(Backend).use(languageDetector).use(initReactI18next).init({
    fallbackLng: 'en',
    backend: {
        // loadPath: `https://dev.facilitatrip.com/api/v1/translation/?lang={{lng}}`,
        loadPath: () => {
            const host = window.location.host;
            return host.includes('localhost') ? `https://dev.facilitatrip.com/api/v1/translation/?lang={{lng}}` : `/api/v1/translation/?lang={{lng}}`;
        },
        parse: function(data) {
            const translations = JSON.parse(data);
            const first_key = Object.keys(translations)[0];
            if (first_key) {
                return translations[first_key];
            }
            return data;
        },
        // loadPath: `${WP_BASE_HREF}/translation/language/{{lng}}.json`
        // loadPath: `${API_HREF}/phrase/test_file/`
    },
    debug: true,
    interpolation: {
        escapeValue: false,
    },
    joinArrays: '\n',
    detection: { order:['facilitatripLanguageDetector', 'querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'] },
    supportedLngs: ['en', 'en-GB', 'en-AU', 'fr', 'it', 'es', 'de', 'nl', 'hu', 'sv', 'no', 'zh-CN', 'ca', 'tr', 'ru', 'uk', 'pt', 'pt-BR', 'da'],
});


export default i18n;